import { EFeatureStatus, ERecordLength } from '../../../data/Constants';
import type { IProcosState } from '../../../../types';

export const initialState: IProcosState = {
  workItems: [],
  newWorkItem: null,
  activeWorkItem: null,
  isEditMode: false,
  isDataUpdated: false,
  isProductStatusUpdated: false,
  isDataReset: false,
  markets: [],
  product: {
    name: '',
    id: '',
    ma: {
      initialMarkets: [],
      updatedMarkets: [],
      type: '',
    }, //ma = Market Associations
  },
  features: {
    data: null,
    ma: {}, //ma = Market Associations,
    status: { updated: null, initial: null },
    recordsPerPage: ERecordLength.RL100,
  },
  saveData: null,
  productStatus: EFeatureStatus.Active,
  productStatusInMaster: EFeatureStatus.Active,
  featureStatus: false,
  effectivityResult: {},
  isCreateRuleInvoked: false,
  isBatchSaveComplete: false,
  batchSaveStatus: [],
};
